import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { MatDialogRef, MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-switch-user-dialog',
  templateUrl: './switch-user-dialog.component.html',
  styleUrls: ['./switch-user-dialog.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule
  ]
})
export class SwitchUserDialogComponent {
  switchUserForm: FormGroup;

  constructor(
    private dialogRef: MatDialogRef<SwitchUserDialogComponent>,
    private fb: FormBuilder
  ) {
    this.switchUserForm = this.fb.group({
      username: ['', [Validators.required]],
      password: ['', [Validators.required]]
    });
  }

  onSubmit(): void {
    if (this.switchUserForm.valid) {
      this.dialogRef.close(this.switchUserForm.value);
    }
  }

  onCancel(): void {
    this.dialogRef.close();
  }
} 